import { useDonation } from '../../context/DonationContext';
import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';

export default function PersonalInfo() {
    const { donation, updateDonation } = useDonation();
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    // Formatea el nombre a formato capital (Primera Letra Mayúscula)
    const formatName = (name) => {
        return name.toLowerCase().split(' ').map(word =>
            word.charAt(0).toUpperCase() + word.slice(1)
        ).join(' ');
    };

    const formatLastName = (last_name) => {
        return last_name.toLowerCase().split(' ').map(word =>
            word.charAt(0).toUpperCase() + word.slice(1)
        ).join(' ');
    };

    const validateEmail = (email) => {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(email);
    };

    const validatePhone = (phone) => {
        const re = /^[+]?[(]?[0-9]{1,4}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{3,6}$/;
        return re.test(phone);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const newErrors = {};

        // Validaciones
        if (!donation.personalInfo?.name) newErrors.name = 'Nombre/s es requerido';
        if (!donation.personalInfo?.last_name) newErrors.last_name = 'Apellidos son requeridos';
        if (!donation.personalInfo?.nickname) newErrors.nickname = 'Nombre elegido';
        if (!donation.personalInfo?.email) {
            newErrors.email = 'Email es requerido';
        } else if (!validateEmail(donation.personalInfo.email)) {
            newErrors.email = 'Email no válido';
        }
        if (!donation.personalInfo?.country) newErrors.country = 'País es requerido';
        if (!donation.personalInfo?.phone) {
            newErrors.phone = 'Teléfono es requerido';
        } else if (!validatePhone(donation.personalInfo.phone)) {
            newErrors.phone = 'Teléfono no válido';
        }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        navigate('/donar/pago');
    };

    return (
        <form onSubmit={handleSubmit} className="max-w-md mx-auto p-4">
            <h2 className="text-2xl font-bold mb-6 text-gray-800">Tus datos</h2>

            {/* Nombre Completo */}
            <div className="mb-4">
                <label className="block mb-2 text-gray-700">Nombres</label>
                <input
                    type="text"
                    required
                    className={`w-full p-3 border rounded-lg ${errors.name ? 'border-red-500' : 'border-gray-300'}`}
                    value={donation.personalInfo?.name || ''}
                    onChange={(e) => updateDonation({
                        personalInfo: {
                            ...donation.personalInfo,
                            name: formatName(e.target.value)
                        }
                    })}
                    placeholder="Ej: María García López"
                />
                {errors.name && <p className="text-red-500 text-sm mt-1">{errors.name}</p>}
            </div>

            <div className="mb-4">
                <label className="block mb-2 text-gray-700">Apellidos</label>
                <input
                    type="text"
                    required
                    className={`w-full p-3 border rounded-lg ${errors.last_name ? 'border-red-500' : 'border-gray-300'}`}
                    value={donation.personalInfo?.last_name || ''}
                    onChange={(e) => updateDonation({
                        personalInfo: {
                            ...donation.personalInfo,
                            last_name: formatLastName(e.target.value)
                        }
                    })}
                    placeholder="Ej: María García López"
                />
                {errors.last_name && <p className="text-red-500 text-sm mt-1">{errors.last_name}</p>}
            </div>

            <div className="mb-4">
                <label className="block mb-2 text-gray-700">Nombre elegido</label>
                <input
                    type="text"
                    required
                    className={`w-full p-3 border rounded-lg ${errors.name ? 'border-red-500' : 'border-gray-300'}`}
                    value={donation.personalInfo?.nickname || ''}
                    onChange={(e) => updateDonation({
                        personalInfo: {
                            ...donation.personalInfo,
                            nickname: formatName(e.target.value)
                        }
                    })}
                    placeholder="Gabo"
                />
                {errors.nickname && <p className="text-red-500 text-sm mt-1">{errors.nickname}</p>}
            </div>

            {/* Email */}
            <div className="mb-4">
                <label className="block mb-2 text-gray-700">Correo electrónico</label>
                <input
                    type="email"
                    required
                    className={`w-full p-3 border rounded-lg ${errors.email ? 'border-red-500' : 'border-gray-300'}`}
                    value={donation.personalInfo?.email || ''}
                    onChange={(e) => updateDonation({
                        personalInfo: {
                            ...donation.personalInfo,
                            email: e.target.value.trim()
                        }
                    })}
                    placeholder="ejemplo@correo.com"
                />
                {errors.email && <p className="text-red-500 text-sm mt-1">{errors.email}</p>}
            </div>

            {/* País */}
            <div className="mb-4">
                <label className="block mb-2 text-gray-700">País</label>
                <select
                    required
                    className={`w-full p-3 border rounded-lg ${errors.country ? 'border-red-500' : 'border-gray-300'}`}
                    value={donation.personalInfo?.country || ''}
                    onChange={(e) => updateDonation({
                        personalInfo: {
                            ...donation.personalInfo,
                            country: e.target.value
                        }
                    })}
                >
                    <option value="">Selecciona tu país</option>
                    <option value="México">México</option>
                    <option value="Colombia">Colombia</option>
                    <option value="Argentina">Argentina</option>
                    <option value="España">España</option>
                    <option value="Otro">Otro</option>
                </select>
                {errors.country && <p className="text-red-500 text-sm mt-1">{errors.country}</p>}
            </div>

            {/* Teléfono */}
            <div className="mb-6">
                <label className="block mb-2 text-gray-700">Número de teléfono</label>
                <input
                    type="tel"
                    required
                    className={`w-full p-3 border rounded-lg ${errors.phone ? 'border-red-500' : 'border-gray-300'}`}
                    value={donation.personalInfo?.phone || ''}
                    onChange={(e) => updateDonation({
                        personalInfo: {
                            ...donation.personalInfo,
                            phone: e.target.value
                        }
                    })}
                    placeholder="+52 55 1234 5678"
                />
                {errors.phone && <p className="text-red-500 text-sm mt-1">{errors.phone}</p>}
            </div>

            <button
                type="submit"
                className="w-full bg-blue-600 text-white py-3 px-6 rounded-lg hover:bg-blue-700 transition-colors font-medium"
            >
                Continuar al pago
            </button>
        </form>
    );
}